import React from "react";

const Section3Values = () => (
  <>
    <h2>3. Our Values</h2>
    <p>At <i>Comparedly</i>, our values are not mere words on a wall — they’re the foundation of every product decision, customer interaction, and line of code. These principles guide how we build, how we collaborate, and how we serve.
    </p>
    <h3>3.1 Clarity Over Complexity</h3>
    <p>We believe that simplicity is the ultimate sophistication. In a world flooded with dashboards and data overload, we strive to distill what matters — helping our users see the signal, not the noise.
    </p>
    <p>
    <strong>If a metric isn’t useful, we don’t show it. If a feature isn’t intuitive, we don’t ship it.
    </strong></p>
    <h3>3.2 Empowerment Through Insights</h3>
    <p><i>Comparedly</i> is built to empower — not overwhelm. Our tools are designed to help everyone, regardless of technical expertise, feel confident in making data-informed decisions. Every insight we surface is meant to drive action and inspire confidence.
    </p>
    <p>
    <strong>Data shouldn’t require a translator. We make sure it doesn’t.
    </strong></p>
    <h3>3.3 Obsess Over User Experience</h3>
    <p>From onboarding to ongoing analysis, we obsess over making the user journey smooth, insightful, and joyful. We listen carefully, test relentlessly, and iterate purposefully to serve what real users actually need.
    </p>
    <p>
    <strong>Our users don’t adapt to the tool — the tool adapts to them.
    </strong></p>
    <h3>3.4 Integrity in Every Insight</h3>
    <p>We value accuracy and transparency. When it comes to analytics, precision matters — and we take the responsibility seriously. Our platform is built to deliver trustworthy insights that reflect reality, not vanity.
    </p>
    <p>
    <strong>Our metrics have meaning — and you can count on them.
    </strong></p>
    <h3>3.5 Progress, Not Perfection</h3>
    <p>We are learners, builders, and changemakers. We’re not afraid to experiment and evolve. Every challenge is a chance to grow — and we bring that spirit to both our platform and our partnerships.
    </p>
    <p>
    <strong>We improve every week. So should your strategy.
    </strong></p>

  </>
);

export default Section3Values;
